import React from "react";
import { css, useTheme } from "@emotion/react";

import Collapse from "core/Components/Collapse";

type Props = {
    children: React.ReactNode,
    showBurgerMenu: boolean,
};

const BurgerNavMainContainer: React.FC<Props> = ({ children, showBurgerMenu }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        width: 100%;
        height: 100%;
    `;

    const collapseStyle = css`
        ${theme.breakpoints.down('lg')} {
            ${showBurgerMenu && css`
                height: 100% !important;
            `}
        }
    `;

    return (
        <Collapse isOpen={showBurgerMenu} css={collapseStyle}>
            <div css={style}>
                {children}
            </div>
        </Collapse>
    );
};

export default BurgerNavMainContainer;
